<template>
    <v-col cols=12>
        <v-card>
            <v-card-text class="ma-1">
                {{salutation}}
            </v-card-text>
        </v-card>
    </v-col>
</template>

<script>
    import axios from 'axios';

    /**
     * Display a greeting to the user
     */
    export default {
        props:[],

        data: function() {
            return {
                salutations:   [],
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){
            this.loadGreetings();
        },

        methods: {
            /**
             * Load the data describing all the panels for the dashboard to host by requesting them from the API
             */
            loadGreetings(){
                axios.get('api/salutations')
                .then(response => {
                    this.salutations = response.data;
                })
                .catch(error => {
                    console.log(error);
                });
            },
        },

        computed: {
            salutation: function(){
                var index =  Math.floor( Math.random() * this.salutations.length );
                var salutation = this.salutations[index];
                return salutation;
            }
        }
    }
</script>
